import { render, staticRenderFns } from "./TpvOrder.vue?vue&type=template&id=737f00d5&scoped=true&"
import script from "./TpvOrder.vue?vue&type=script&lang=js&"
export * from "./TpvOrder.vue?vue&type=script&lang=js&"
import style0 from "./TpvOrder.vue?vue&type=style&index=0&id=737f00d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737f00d5",
  null
  
)

export default component.exports